import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_CONSULTATION = "GET_LIST_CONSULTATION";
export const GET_DETAIL_CONSULTATION = "GET_DETAIL_CONSULTATION";
export const SET_LIST_CONSULTATION = "SET_LIST_CONSULTATION";
export const SET_DETAIL_CONSULTATION = "SET_DETAIL_CONSULTATION";


const state = {
    consultation: [],
    consultationDetail: {}
};

const getters = {
    consultation(state) {
        return state.consultation;
    },
    consultationDetail(state) {
        return state.consultationDetail;
    },


};

const actions = {
    [GET_LIST_CONSULTATION](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_CONSULTATION}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_CONSULTATION, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_CONSULTATION](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CONSULTATION}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CONSULTATION, data);
                }
                resolve(data);
            });
        });
    },

};

const mutations = {
    [SET_LIST_CONSULTATION](state, data) {
        state.consultation = data.data;
    },
    [SET_DETAIL_CONSULTATION](state, data) {
        state.consultationDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};